class Component {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `${storeId}/component`;
    }

    get(template,componentKey, params) {
        
        return this.http.get(`${this.path}/${template}/${componentKey}`, { params })
            .then(resp => {
                const { data, status } = resp;
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({})
                }
            });
    }

    getAnalyticsData(template, vanityUrl) {
        return this.get('analytics',template, { path: vanityUrl });
    }

}

export default Component;
